import { Fragment } from "@emotion/react/jsx-runtime";
import type { FC } from "react";

export const WhiteSpace: FC = () => {
  return <Fragment>{` `}</Fragment>;
};
